import React, { useEffect, useRef, useState } from "react";

interface VisibleElement {
  [key: string]: boolean;
}

const Excellence: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState<VisibleElement>({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible({ main: true });
        }
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="bg-gray-50">
      <section ref={sectionRef} className="relative w-full py-24">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 mb-20">
            <div>
              <h2
                className={`text-6xl md:text-7xl font-light leading-tight transition-all duration-700 ${
                  visible.main ? "animate-fade-in-up" : "opacity-0"
                }`}
              >
                Operational Excellence
              </h2>
            </div>

            <div className="flex items-center">
              <div className="relative group">
                <div className="border-t-4 pt-8 px-8 py-6 bg-white rounded-2xl shadow-2xl shadow-sky-100/50 border border-sky-200 hover:shadow-3xl hover:shadow-sky-200/50 transition-all duration-500 transform group-hover:-translate-y-1">
                  <p className="text-gray-700 text-lg leading-relaxed font-medium">
                    Pioneering advanced materials and sustainable technologies
                    through dedicated research and innovation.
                  </p>

                  <div className="absolute -bottom-2 -right-2 w-16 h-16 bg-sky-200/20 rounded-full blur-xl"></div>
                  <div className="absolute -top-2 -left-2 w-12 h-12 bg-sky-100/30 rounded-full blur-lg"></div>
                </div>

                <div className="absolute inset-0 bg-gradient-to-r from-sky-200/0 via-sky-100/0 to-blue-200/0 rounded-2xl group-hover:from-sky-200/10 group-hover:via-sky-100/5 group-hover:to-blue-200/10 transition-all duration-500 blur-xl -z-10"></div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
              <div className="lg:col-span-3 space-y-8">
                <div className="prose prose-lg">
                  <p className="text-gray-600 leading-relaxed">
                    At DEVANANTA R&D PRIVATE LIMITED, we are pioneers in
                    reshaping the future of advanced materials and sustainable
                    technologies. Born from the passion and expertise of our
                    co-founders, Devyansh Agrawal and Manisha, our company is
                    committed to driving innovation at the intersection of
                    research, development, and commercialization.
                  </p>

                  <p className="text-gray-600 leading-relaxed">
                    With deep roots in cutting-edge research and technology, we
                    specialize in the applications of advanced and revolutionary
                    materials with limitless potential. Our work spans across
                    critical sectors including energy, defense, space, and
                    industry.
                  </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 pt-2">
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-sky-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-600 text-sm">
                      Cutting-edge research & development
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-sky-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-600 text-sm">
                      Sustainable technology solutions
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-sky-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-600 text-sm">
                      Real-world commercial applications
                    </p>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-sky-500 rounded-full mt-2 flex-shrink-0"></div>
                    <p className="text-gray-600 text-sm">
                      Cross-sector innovation
                    </p>
                  </div>
                </div>
              </div>

              <div className="lg:col-span-2">
                <div className="sticky top-8">
                  <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
                    <img
                      src="/excellence.png"
                      alt="Advanced Battery Technology"
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Excellence;
